import { DetailedHTMLProps, FC, SVGProps } from "react";
export const Arrow: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (


<svg className={className} width="56" height="38" viewBox="0 0 56 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.06529 16.3584C1.68457 16.3584 0.565285 17.4777 0.565285 18.8584C0.565285 20.2391 1.68457 21.3584 3.06529 21.3584V16.3584ZM54.8331 20.6262C55.8094 19.6499 55.8094 18.0669 54.8331 17.0906L38.9232 1.18073C37.9469 0.204418 36.364 0.204418 35.3876 1.18073C34.4113 2.15704 34.4113 3.73995 35.3876 4.71626L49.5298 18.8584L35.3876 33.0005C34.4113 33.9768 34.4113 35.5598 35.3876 36.5361C36.364 37.5124 37.9469 37.5124 38.9232 36.5361L54.8331 20.6262ZM3.06529 18.8584V21.3584H53.0653V18.8584V16.3584H3.06529V18.8584Z" fill="white"/>
</svg>

);
